/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]:not([href]):not([tabindex]){color:#046993}a[_ngcontent-%COMP%]:hover:not([href]):not([tabindex]){color:#9d5407}"];
export { styles as styles };
